<script setup>
import { ref, reactive, onMounted, nextTick } from "vue";
import {listStoreByTenantId, merchantChangeStore, merchantLogin, userClubLogin, userLogin} from "@/api/login/login.js";
import { weChatLogin } from "@/api/login/login.js";
import { userLoginHooks } from "@/hooks/user.js";
import { getRoute } from "@/hooks/getRoute.js";
import axios from "axios";

const { route } = getRoute();
const loginCode = ref(route.query.code);
const title = ref(import.meta.env.VITE_API_TITLE);
onMounted(() => {
  if (loginCode.value) {
    handleWxLogin();
  }
});
// 表单信息
const form = ref({});
const phone = ref();
const password = ref();
const password_show = ref(false);
// 临时使用，1：微信登录 2：账号密码登录
const loginType = ref(2);
const showTips = ref(false);
const errMsg = ref("用户名或密码错误");

// 处理登录
async function submit() {
  try {
    const { valid } = await form.value.validate();
    if (valid) {
      const param = ref({
        username: phone,
        password: password,
      });
      const res = await merchantLogin(param.value);
      await userLoginHooks(res, false, false);
      const storeListRes = await listStoreByTenantId({page: 1, pageSize: 1}, {tenantId: res.tenantId, adminId: res.adminId})
      if (storeListRes.list.length <= 0) {
        ElMessage.error("当前用户暂无可用门店，请联系管理员！")
        return
      }
      const storeRes = await merchantChangeStore(storeListRes.list[0].storeId)
      await userLoginHooks(storeRes);
    }
  } catch (err) {
    showTips.value = true;
    errMsg.value = err;
    console.log("不通过:", err);
  }
}
const handleOpenQrCode = (user) => {
  try {
    nextTick(() => {
      new WxLogin({
        id: `qrCodeDialog`,
        appid: import.meta.env.VITE_WECHAT_APPID,
        scope: "snsapi_login",
        redirect_uri: import.meta.env.VITE_WECHAT_REDIRECT_URL,
        fast_login: 1,
        stylelite: 1,
      });
    });
  } catch (err) {
    console.log("err: ", err);
  }
};
const handleWxLogin = async () => {
  try {
    const res = await weChatLogin(loginCode.value);
    await userLoginHooks(res);
  } catch (e) {
    console.log(e);
  }
};
const changeLoginType = () => {
  if (loginType.value == 1) {
    loginType.value = 2;
  } else if (loginType.value == 2) {
    loginType.value = 1;
    handleOpenQrCode();
  } else {
    return;
  }
};
const switchPassword = () => {
  password_show.value = !password_show.value;
};
// ICP备案
const icpBeiAn = ref(import.meta.env.VITE_ICP);
// 公安备案
const gongAnBeiAn = ref(import.meta.env.VITE_GON);
</script>

<template>
  <div class="lg_bg">
    <!--    <div class="lg_bg_mask"></div>-->
    <v-card class="mx-auto my-8" elevation="16" width="523" height="536">
      <div class="login_type" @click="changeLoginType">
        <img
          v-if="loginType == 1"
          src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/login_account.svg"
        />
        <img v-else src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/login_qr.svg" />
      </div>
      <div>
        <div class="txt_center logo_title">
          <img class="logo" src="/src/assets/images/logo.png" />
          <span class="lg_title font-weight-black"> {{ title }} 商家管理端 </span>
        </div>
      </div>

      <v-card-text>
        <v-form
          class="pd_t_3"
          ref="form"
          validate-on="submit lazy"
          @submit.prevent="submit"
        >
          <!-- 微信登录 -->
          <div v-if="loginType === 1">
            <div class="wechat_login">
              <div class="lg_tips txt_center">
                <div class="wechat_login_txt1">微信扫码</div>
                <div class="wechat_login_txt2">一键登录</div>
              </div>
              <div id="qrCodeDialog" class="mg_0_auto"></div>
            </div>
          </div>

          <!-- 账号密码登录 -->
          <div v-if="loginType === 2">
            <div class="input_item">
              <div class="input_item_title flex_left mb10">
                <img class="mr10" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/phone.svg" />
                手机号
              </div>
              <el-input
                v-model="phone"
                placeholder="输入管理员账号"
                style="width: 280px; height: 51px"
                maxlength="11"
              ></el-input>
            </div>
            <div class="input_item mt32">
              <div class="input_item_title flex_left mb10">
                <img
                  class="mr10"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/account.svg"
                />
                密码
              </div>
              <el-input
                v-model="password"
                placeholder="输入账号密码"
                :type="password_show ? 'text' : 'password'"
                style="width: 280px; height: 51px"
                maxlength="16"
              >
                <template #suffix>
                  <span class="input_icon" @click="switchPassword()">
                    <img
                      v-if="password_show"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/hide.svg"
                      style="margin-right: 22px"
                    />
                    <img
                      v-else
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/settings/show.svg"
                      style="margin-right: 22px"
                    />
                  </span>
                </template>
              </el-input>
            </div>
            <!-- 临时使用 -->
            <div style="width: 100%; height: 20px" class="tips_err mg_b_1">
              <transition name="el-zoom-in-top">
                <span v-if="showTips">{{ errMsg }}</span>
              </transition>
            </div>
            <div class="button_box">
              <button class="login">登录</button>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <div class="beian_box">
        <div style="max-height: 21px">
          <el-link
            target="_blank"
            style="color: #eeeeee; margin-right: 10px"
            type="default"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            :underline="false"
            >粤ICP备{{ icpBeiAn }}号</el-link
          >
        </div>
        <div style="max-height: 21px">
          <div class="beian_icon"></div>
          <el-link
            target="_blank"
            style="color: #eeeeee; margin-right: 10px"
            type="default"
            :href="`https://beian.mps.gov.cn/#/query/webSearch?recordcode=${gongAnBeiAn}`"
            :underline="false"
            >粤公网安备{{ gongAnBeiAn }}号</el-link
          >
        </div>
      </div>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.lg_bg {
  width: 100vw;
  height: 100vh;
  background: #1e1e1e;
  //background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  position: relative;
  z-index: 2;
  //.lg_bg_mask {
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  width: 100vw;
  //  height: 100vh;
  //  background: rgba(30, 30, 30, .5);
  //}
  .mx-auto {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .login_type {
      position: absolute;
      top: 0;
      right: 0;
    }
    .v-card-text {
      padding-top: 0;
    }
  }
  .txt_center {
    .lg_title {
      font-size: 14px;
      margin-top: 18px;
    }
  }
  .wechat_login {
    display: flex;
    flex-direction: column;
    align-items: center;
    .lg_tips {
      font-size: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 22px;
      .wechat_login_txt1 {
        color: #796cb4;
      }
    }
    .mg_0_auto {
      padding: 7px;
      // border: 1px solid rgba(0, 0, 0, 0.1);
      // border-radius: 15px;
      // width: 175px;
      // height: 175px;
      overflow: hidden;
    }
  }

  .logo_title {
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo {
      width: 85px;
      height: 85px;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.32);
    }
  }
}
.beian_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.beian_icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 5px;
  background-image: url("@/assets/images/login/hz_icon.png");
  background-position: -40px 0;
  background-repeat: no-repeat;
  vertical-align: middle;
}
::v-deep(.el-input) {
  --el-input-focus-border-color: #796cb4;
  --el-input-border-radius: 15px;
  .is-focus {
    box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset !important;
  }
  .el-input__wrapper {
    height: 44px;
    background-color: #ececf4;
  }
}
::v-deep(.v-card) {
  padding: 58px 110px;
  border-radius: 15px;
}
.button_box {
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 47px;
  .login {
    background-color: #4caf50;
    color: white;
    width: 175px;
  }
}
</style>
